import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './field-description.component.module.styl';

import type {ComponentPropsWithoutRef, ReactNode, Ref} from 'react';


export const Types = {
    DEFAULT: 'Types.DEFAULT',
    ERROR: 'Types.ERROR',
} as const;
const TYPES_CLASSES = {
    [Types.DEFAULT]: null,
    [Types.ERROR]: 'field-description_error',
};
const classNames = withCssModule(styles);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TypesValues = [...Object.values(Types)] as const;
type Type = typeof TypesValues[number];

type NativeProps = ComponentPropsWithoutRef<'div'>;
interface Props extends NativeProps {
    /**
     * Field description caption
     * @deprecated It will be removed in 6 months 09-15-2025. use children
     */
    caption?: ReactNode,

    /**
     * Show field description
     * @deprecated It will be removed in 6 months 09-15-2025. do not render if not shown
     */
    shown?: boolean,

    /**
     * Type of description
     * @deprecated It will be removed in 6 months 09-15-2025. use color
     */
    type?: Type,

    /**
     * Error or default color
     * */
    color?: Type,

    /**
     * Ref to the HTMLDivElement
     * */
    ref?: Ref<HTMLDivElement>,
}

/**
 * FieldDescription component is used to display messages or errors below the form field.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/forms-field-description--documentation}
 * */
export const FieldDescription = forwardRef<HTMLDivElement, Props>(function FieldDescription(props, ref) {
    const {color, type, shown, caption, ...nativeProps} = props;

    const fieldDescriptionClasses = classNames(
        'field-description', nativeProps.className,
        {
            'field-description_shown': shown ?? true,
        },
        TYPES_CLASSES[type ?? Types.DEFAULT],
        TYPES_CLASSES[color ?? Types.DEFAULT],
    );

    const defaultRole = (type === Types.ERROR || color === Types.ERROR) ? 'alert' : undefined;

    return (
        <div
            {...nativeProps}
            role={nativeProps?.role ?? defaultRole}
            className={fieldDescriptionClasses}
            ref={ref}>
            {caption}{nativeProps.children}
        </div>
    );
});

FieldDescription.displayName = 'FieldDescription';
